(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osoth-scroll-customb2b"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('teekop-scroll-story')) {
    class TeekopScrollStory extends HTMLElement {
      connectedCallback() {
        this.steps = this.querySelectorAll('.content-step');
        this.mediaItems = this.querySelectorAll('.media-item');
        if (!this.steps.length || typeof IntersectionObserver === 'undefined') return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const index = entry.target.getAttribute('data-step');
              this.mediaItems.forEach((media) => {
                media.classList.toggle('active', media.getAttribute('data-index') === index);
              });
            });
          },
          { rootMargin: '-40% 0px -40% 0px' }
        );
        this.steps.forEach((step) => this.observer.observe(step));
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
      }
    }

    customElements.define('teekop-scroll-story', TeekopScrollStory);
  }

  } catch(e) { console.error(e); }
})();
})();
